// eslint-disable-next-line import/no-anonymous-default-export
export default {
  api: {
    baseURL: 'https://api.apcsmusic.com',
  },
  client: {
    baseURL: 'https://api.apcsmusic.com',
  },
};
// export default {
//   api: {
//     baseURL: 'http://localhost:8080',
//   },
//   client: {
//     baseURL: 'http://localhost:8080',
//   },
// };
// export default {
//   api: {
//     baseURL: 'https://e5ca-2a09-bac1-34a0-18-00-2e4-ae.ngrok-free.app',
//   },
//   client: {
//     baseURL: 'https://e5ca-2a09-bac1-34a0-18-00-2e4-ae.ngrok-free.app',
//   },
// };
